<div class="card-wrap recc-card search-classcard" (click)="classOrProgramRoute(classOrProgramInfo)">
    <div class="card paid-card text-left">
        <div class="clip-img card-variant">
            <img *ngIf="(classOrProgramInfo?.image?.path || classOrProgramInfo?.image?.name || classOrProgramInfo?.thumbnailUrl)" [src]="classOrProgramInfo?.thumbnailUrl ? classOrProgramInfo?.thumbnailUrl : imageUrl+classOrProgramInfo?.image?.path + classOrProgramInfo?.image?.name "  class="card-img-top" alt="card image" />
            <img *ngIf="!(classOrProgramInfo?.image?.path || classOrProgramInfo?.image?.name) &&  !classOrProgramInfo?.thumbnailUrl" src=""  class="card-img-top" alt="card image" />
            
            <span class="clip-icn">
                <img src="assets/images/video-icon.png" alt="video-icon"/>
            </span>
            <!-- for class -->
            <p class="info info-desc rightAlign" *ngIf="classOrProgramInfo?.duration">
                <img class="watch-icn watchIcon" src="assets/images/watch-icn.svg" alt="watch" />
                <span class="time" *ngIf="classOrProgramInfo?.duration">
                    {{ classOrProgramInfo?.duration }} Mins 
                </span>
            </p>
            <!-- for programs -->
            <p  class="info info-desc" *ngIf="classOrProgramInfo?.week">
                <span  class="time" >
                    {{classOrProgramInfo?.week ? classOrProgramInfo?.week : 0}} week 
                </span>
                <span  class="classes" *ngIf="classOrProgramInfo?.classes">
                    {{ classOrProgramInfo?.classes ? classOrProgramInfo?.classes : 0}} classes 
                </span>
            </p>
            <!-- <span class="clip-tagtxt">
                {{ classOrProgramInfo?.label }}
            </span> -->
            <!-- <span class="card-heart-icn" >
                <img src="assets/images/heart-icn.svg" alt="">
            </span> -->
        </div>
        <div class="card-body">
            <div class="schedule d-flex justify-content-between">
                <p class="card-text"> {{ classOrProgramInfo?.name}}</p>
                <span class="lavel"><img [src]="classOrProgramInfo?.level ? 'assets/images/'+classOrProgramInfo?.level+'.png' : 'assets/images/6.png'" alt="graph" /> 
                    {{classOrProgramInfo?.level}}
                </span>
            </div>

            <div class="card-tags text-md-left">
                <a class="tag" *ngFor="let i of classOrProgramInfo?.tagsData | slice:0:3">
                    {{i?.name}}
                </a>
            </div>
            <div class="card-profile">
                <!-- for class only -->
                <div class="profile-name" *ngIf="classOrProgramInfo?.instructor && classOrProgramInfo?.instructor[0]" (click)="goToInstructorPage($event, classOrProgramInfo?.instructor[0]?.slug)">
                    <span class="profile-img"><img [src]="imageUrl+classOrProgramInfo?.instructor[0]?.image?.path + classOrProgramInfo?.instructor[0]?.image?.name" alt="profile" /></span>
                    <span class="name"><span>{{ classOrProgramInfo?.instructor[0]?.firstName}} {{ classOrProgramInfo?.instructor[0]?.lastName}}</span></span>
                </div>
                <!-- for programs only-->
                <div class="profile-name" *ngIf="classOrProgramInfo?.instructors && classOrProgramInfo?.instructors[0]" (click)="goToInstructorPage($event, classOrProgramInfo?.instructors[0]?.slug)">
                    <span class="profile-img"><img [src]="imageUrl+classOrProgramInfo?.instructors[0]?.image?.path + classOrProgramInfo?.instructors[0]?.image?.name" alt="profile" /></span>
                    <span class="name"><span>{{ classOrProgramInfo?.instructors[0]?.firstName}} {{ classOrProgramInfo?.instructors[0]?.lastName}}</span></span>
                </div>
                <a *ngIf="classOrProgramInfo?.amount"  class="card-price">&#36; {{classOrProgramInfo?.amount}}</a>
            </div>
        </div>
    </div>
</div>